import React from 'react'
import icons from "../../../utils/iconFontAwesome"
interface IconTypes {
    icon:string,
    classname?:string
}
const Icon = ({icon, classname}:IconTypes) => {
    const Icon = icons[icon]
  return (
    <Icon className={classname}/>
  )
}

export default Icon